import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const StoreCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${p => p.theme.bg.secondary};
  border-radius: 5px;
  padding: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing100};
  max-width: 600px;
`;

export const StoreInfo = styled.div`
  margin-left: ${layout.measurements.spacing050};
  font-size: ${layout.measurements.fontSizeSmall};
`;
